import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ProfileUpdateRequestImpl } from "shared/cubiq-model-multi-asset";
import { BfxUserSettingsService, BfxUserSettingsComponentState } from "./bfx-user-settings.service";
import { BfxUserSettingsPageComponent } from "./bfx-user-settings-page.component";
import {
  ProfileSettingKeys,
  SystemConfigPromiseService,
  ProfilePromiseActionService,
  UserPromiseLookupService,
  SysFeatures,
  ActiveUser,
} from "shared/cubiq-services";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  IBfxUserSettingsPageSubComponent,
  BfxUserSettingsValidityState,
} from "app/bfx-user-settings/bfx-user-settings-page.component";
import { BfxUserSettingsComponent } from "app/bfx-user-settings/bfx-user-settings.component";
import { BfxTradeBlotterSettingsComponent } from "app/bfx-user-settings/bfx-trade-blotter-settings.component";
import { BfxInputControlStateEnum } from "../bfx-interface-controls/models/bfx-interface-controls.enums";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-trade-blotter-settings-preferences",
  templateUrl: "./html/bfx-trade-blotter-settings-preferences.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BfxTradeBlotterSettingsPeferencesComponent
  implements IBfxUserSettingsPageSubComponent<BfxTradeBlotterSettingsComponent>, OnInit, OnDestroy
{
  public activeSubComponent: number = 2;
  public categoryComponent: BfxTradeBlotterSettingsComponent = null;
  public parentComponent: BfxUserSettingsComponent = null;
  public buyAndSell: boolean = true;
  public disableBuyAndSell: boolean = false;
  public panelHeight: number = 0;
  private tempValueToUpdateActiveUser: string;
  public ready: boolean = false;
  public tradePreferencesObj = {
    buyAndSellModel: null,
  };
  constructor(
    public userSettingsService: BfxUserSettingsService,
    public profileService: ProfilePromiseActionService,
    public userService: UserPromiseLookupService,
    public element: ElementRef,
    public translationService: TranslateService,
    private sysConfigService: SystemConfigPromiseService,
    private cd: ChangeDetectorRef,
  ) {}

  public onTabActivated(event: any): void {}

  enableBuyAndSellToggle($event: any) {
    this.buyAndSell = !this.buyAndSell;
    this.parentComponent.validate(null);
  }

  public initialize(): void {
    let activeUser: ActiveUser = this.parentComponent.activeUser;
    if (
      activeUser.profileSettings &&
      activeUser.profileSettings.has(ProfileSettingKeys.userProfileSettingsTradeBlotterPreferences)
    ) {
      let savedSettings = this.tradePreferencesObj;
      savedSettings = JSON.parse(
        activeUser.profileSettings.get(
          ProfileSettingKeys.userProfileSettingsTradeBlotterPreferences,
        ),
      );

      if (
        savedSettings.hasOwnProperty("buyAndSellModel") &&
        savedSettings.buyAndSellModel !== null &&
        savedSettings.buyAndSellModel == "y"
      ) {
        this.buyAndSell = true;
      } else {
        this.buyAndSell = false;
      }
      setTimeout(() => {
        this.ready = true;
        this.cd.detectChanges();
      }, 100);
    } else {
      setTimeout(() => {
        this.ready = true;
        this.cd.detectChanges();
      }, 200);
    }
  }

  ngOnInit() {}

  ngOnDestroy() {}

  public validate(): Promise<BfxUserSettingsValidityState> {
    return new Promise<BfxUserSettingsValidityState>((res, reject) => {
      let state = BfxUserSettingsValidityState.VALID;
      //logger.out.info(`${this.constructor.name}.validate() valid:BfxUserSettingsValidityState.${BfxUserSettingsValidityState[state]}`);
      this.cd.detectChanges();
      res(state);
    });
  }

  public reset(): Promise<void> {
    return new Promise<void>((res, reject) => {
      let activeUser: ActiveUser = this.parentComponent.activeUser;
      if (
        activeUser.profileSettings &&
        activeUser.profileSettings.has(
          ProfileSettingKeys.userProfileSettingsTradeBlotterPreferences,
        )
      ) {
        let savedSettings = this.tradePreferencesObj;
        savedSettings = JSON.parse(
          activeUser.profileSettings.get(
            ProfileSettingKeys.userProfileSettingsTradeBlotterPreferences,
          ),
        );
        if (
          savedSettings.hasOwnProperty("buyAndSellModel") &&
          savedSettings.buyAndSellModel !== null &&
          savedSettings.buyAndSellModel == "y"
        ) {
          this.buyAndSell = true;
        } else {
          this.buyAndSell = false;
        }
      } else {
        this.buyAndSell = false;
      }
      res();
    });
  }

  public save(request: ProfileUpdateRequestImpl): void {
    let savedTempSetting: CubiqTS.ProfileSettingImpl = request.settings.find((setting) => {
      return (
        setting.profileSettingKey == ProfileSettingKeys.userProfileSettingsTradeBlotterPreferences
      );
    });

    let valuesToSave = [];
    let objToSave = this.tradePreferencesObj;

    if (this.buyAndSell === true && this.disableBuyAndSell === false) {
      objToSave.buyAndSellModel = "y";
    } else {
      objToSave.buyAndSellModel = "n";
    }
    valuesToSave.push(objToSave);
    let settingObject: CubiqTS.ProfileSettingImpl = new CubiqTS.ProfileSettingImpl();
    settingObject.profileSettingKey = ProfileSettingKeys.userProfileSettingsTradeBlotterPreferences;
    this.tempValueToUpdateActiveUser = JSON.stringify(objToSave);
    settingObject.profileSettingValue = this.tempValueToUpdateActiveUser;
    if (savedTempSetting === undefined) {
      settingObject.profileSettingValue = this.tempValueToUpdateActiveUser;
      request.settings.push(settingObject);
    } else {
      savedTempSetting.profileSettingValue = this.tempValueToUpdateActiveUser;
    }
  }

  public postReset(): void {}

  public postSave(request: ProfileUpdateRequestImpl): void {
    let activeUser: ActiveUser = this.parentComponent.activeUser;
    if (activeUser.profileSettings) {
      activeUser.profileSettings.set(
        ProfileSettingKeys.userProfileSettingsTradeBlotterPreferences,
        this.tempValueToUpdateActiveUser,
      );
    }
  }

  public onComponentStateChanged(componentState: BfxUserSettingsComponentState): void {
    this.panelHeight = componentState.componentBounds.height - 120;
  }

  public hasDataChanged(): boolean {
    return null;
  }
}
